import React, { useCallback, useEffect } from 'react';
import { StyledForm } from '../../../../SubmitCredentials/molecules/ProviderInputs/ProviderInputs.styles';

export const PROVIDER_INPUT_FORM_ID = 'providerInputs';

export type SubmitProviderInputsPayload = {
  [inputName: string]: string;
};

export type ProviderInputsProps = {
  onSubmit: (payload: SubmitProviderInputsPayload) => void;
  formId?: string;
  setButtonDisabled: (newState: boolean) => void;
};

export const NoFieldsForm: React.FC<ProviderInputsProps> = ({
  onSubmit,
  children,
  setButtonDisabled,
  formId = PROVIDER_INPUT_FORM_ID,
}) => {
  useEffect(() => {
    setButtonDisabled(false);
  }, [setButtonDisabled]);

  const handleSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      onSubmit({});
    },
    [onSubmit]
  );

  return (
    <StyledForm id={formId} onSubmit={handleSubmit} data-testid={formId}>
      {/* We rely on `children` to contain a `button` which will submit this form. */}
      {children}
    </StyledForm>
  );
};
